// @ts-nocheck
import mergeProps from "@store/Framework/Common/Utilities/mergeProps";
import { NoInfer, RecursivePartial } from "@toolkit/Framework/Types/Common";
import { useMemo } from "react";

function useMergeProps<T, U>(object1: T | undefined, object2: U | undefined): T & U;
function useMergeProps<T>(object1: RecursivePartial<NoInfer<T>> | undefined, object2: NoInfer<T> | undefined): T;
function useMergeProps<T>(object1: NoInfer<T> | undefined, object2: RecursivePartial<NoInfer<T>> | undefined): T {
    return useMemo(() => mergeProps(object1, object2), [object1, object2]);
}

export default useMergeProps;
